import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { DateField, Labeled, Show, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const ShowAcademicYear = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Show
      title="Детайли за Академична година"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име">
              <TextField source="name" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Стартира на">
              <DateField
                source="opensOn"
                showTime
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Приключва на">
              <DateField
                source="closesOn"
                showTime
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowAcademicYear;
